import React, { createContext, useContext, useState } from 'react';

import type { SharingModalProps } from 'src/app/pages/starterDashboardV2/shared/components';
import { SharingModal } from 'src/app/pages/starterDashboardV2/shared/components';

type SharingModalPropsInternal = Omit<SharingModalProps, 'isOpen'>;

type SharingModalContextType = {
	startSharingFlow: (props: SharingModalPropsInternal) => void;
	stopSharingFlow: () => void;
};

const SharingModalContext = createContext<SharingModalContextType>({
	startSharingFlow: (_props: SharingModalPropsInternal) => {},
	stopSharingFlow: () => {},
});

export const useSharingModal = () => useContext(SharingModalContext);

export const SharingModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [sharingModalProps, setSharingModalProps] = useState<SharingModalProps | null>(null);
	const [modalKey, setModalKey] = useState(0);

	const startSharingFlow = (props: SharingModalPropsInternal) => {
		setModalKey((prev) => prev + 1);
		// FIXME this casting seems wrong => if there's mapping to be done, it should be done properly
		setSharingModalProps({ ...(props as SharingModalProps), defaultOpen: true });
	};

	const stopSharingFlow = () => {
		setSharingModalProps(null);
	};

	return (
		<SharingModalContext.Provider value={{ startSharingFlow, stopSharingFlow }} data-testid="sharing-modal-context">
			{children}
			{sharingModalProps && <SharingModal key={modalKey} {...sharingModalProps} />}
		</SharingModalContext.Provider>
	);
};
